import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { CommandProgress } from '@rocksoft/mdm-sdk-v2';
import { CommandProgressStoreActions } from '../command-progress';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router/index';

@Injectable()
export class CommandProgressResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly store: Store<CommandProgress>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.store.dispatch(
          CommandProgressStoreActions.CommandProgressResolverActions.commandProgressRequested({
            udid: udid,
            page: 1,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
